import { createSelector } from "reselect";
import { AppRootState, ProductsPageState } from "../../../lib/types/screen";

//ProductsPage screen componentiga daxldor bulgan storageini (react storedan) qulga olish. (screen.ts)
const selectProductsPage = (state: AppRootState) => state.productsPage;

//va malumotlarni qabul qilish(retrieve)
export const retrieveShop = createSelector(
  selectProductsPage,
  (productsPage: ProductsPageState) => productsPage.shop,
);

export const retrieveChosenProduct = createSelector(
  selectProductsPage,
  (productsPage: ProductsPageState) => productsPage.chosenProduct,
);

export const retrieveProducts = createSelector(
  selectProductsPage,
  (productsPage: ProductsPageState) => productsPage.products,
);
// by yerdagi (productsPage) => selectProductsPage qaytargan qiymat, yani state.ProductsPage
